import React from 'react';
import { Col, FormGroup, Row, OverlayTrigger, Tooltip, Glyphicon } from 'react-bootstrap';
import { Switch, TextBox, UrlBox, EmailBox, CurrencyBox, DatePicker, CheckBox } from 'fw/forms';
import { Button, Label, ActionButton } from 'fw/components';
import { Address, PhoneBox, BestContactTimeCombo, TimeZoneCombo, SponsorLevelCombo } from 'areas/shared/controls'
import { SetupTab } from 'areas/shared/pages/setup';
import * as Modals from 'fw/globals/Modals';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import APISystem from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { SponsorCommentsGrid } from 'areas/shared/components';
import queryString from 'query-string';

class SponsorInfoTab extends SetupTab {
    initialForm() {
        var params = queryString.parse(this.props.setupProps.location.search);
        if (!this.props.selectedId && params.paypalInvoiceId)
            return this.setScreenByInvoice(params.paypalInvoiceId);

        return {
			originalEmail: "",
			userId: null,
			disableUserFields: false,
            sponsorName: "",
            website: "",
			phones: [],
			sameMailingAddress: true,
            active: true,
            subscribed: true,
            rowVersion: null
        }
    }

    setScreenByInvoice(paypalInvoiceId) {
        this.setState({
            form: {
                originalEmail: "",
                userId: null,
                disableUserFields: false,
                sponsorName: "",
                website: "",
                phones: [],
                sameMailingAddress: true,
                active: true,
                subscribed: true,
                rowVersion: null
            },
        });

        var rq = {
			paypalInvoiceId: paypalInvoiceId
		};

        API.Sponsor.get('/sponsorSetup/getScreenByInvoice',
			rq,
			{
				success: (r) => {
					this.setState({
						form: {
							...r.data,
                            savedActive: undefined,
							original: JSON.parse(JSON.stringify(r.data)),
						},
					});
                    this._address._update(r.data.address);
                    if (this.state.form.phones !== null && this.state.form.phones !== undefined && this.state.form.phones.length === 0)
                        this.handleAddPhone();
				},
			},
			{ block: false }
		);
	}

    privileges() {
        return {
            add: App.hasPrivilege("AdminSponsorSetupAdd"),
            edit: App.hasPrivilege("AdminSponsorSetupEdit")
        }
    }

    urls() {
        return {
            get: API.Sponsor.url('/sponsorSetup/getSponsorInfo'),
            save: API.Sponsor.url('/sponsorSetup/saveSponsorInfo'),
            create: API.Sponsor.url('/sponsorSetup/createSponsor')
        }
    }

    getRequest(selectedId) {
        return {
            sponsorId: selectedId
        }
    }

    handleResendRegistration = () => {
        const me = this;

        Modals.confirm("This will resend the registration email to all pending users. Are you sure?", function () {
            API.Sponsor.post('/sponsorSetup/resendRegistration', { sponsorId: me.props.selectedId }, {
                success: (r) => {
                    me.props.onSuccess(r.message);
                },
                error: (r) => {
                    me.props.onError(r.error);
                }
            });
        });
    }

    afterSave = (entityId, data) => {
        window.location.reload();
    }

    saveRequest() {
        return {
            sponsorId: this.props.selectedId,
            sponsorName: this.state.form.sponsorName,
            website: this.state.form.website,
            active: this.state.form.active,
            subscribed: this.state.form.subscribed,
            onboardDate: this.state.form.onboardDate,
            activationDate: this.state.form.activationDate,
            expirationDate: this.state.form.expirationDate,
            sponsorLevelId: this.state.form.sponsorLevelId,
            membershipAmount: this.state.form.membershipAmount,
			phones: this.state.form.phones,
            address: this.state.form.address,
			mailingAddress: this.state.form.mailingAddress,
			sameMailingAddress: this.state.form.sameMailingAddress,
            rowVersion: this.state.form.rowVersion,
            paypalInvoiceId: this.state.form.paypalInvoiceId,
            paypalInvoiceMembershipItemId: this.state.form.paypalInvoiceMembershipItemId,
			userId: this.state.form.userId,
            userFirstName: this.state.form.userFirstName,
            userLastName: this.state.form.userLastName,
            userEmail: this.state.form.userEmail,
            userTitle: this.state.form.userTitle,
			userPrimaryPhone: this.state.form.userPrimaryPhone,
			userBestContactTimeCode: this.state.form.userBestContactTimeCode,
			userTimeZoneCode: this.state.form.userTimeZoneCode,
			paymentTerms: this.state.form.paymentTerms
        }
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={8}>
                    </Col>
                    <Col md={2}>
                        <Button id="btnCancel" bsStyle="link" className="pull-right" onClick={this.handleCancel}>Cancel</Button>
                    </Col>
                    <Col md={2}>
                        <Button id="btnSave" bsStyle="primary" onClick={this.handleSave}>Save Changes</Button>
                    </Col>
                </Row>

            </React.Fragment>
        );
    }

    renderActionButtons = () => {
        if (this.state.adding)
            return null;

        return (
            <div className="pull-right">
                {(App.hasPrivilege("AdminUserSetupReset") && this.state.form.pendingUsers) ?
                    <ActionButton className="pull-right" id="btnResendRegistration" onClick={this.handleResendRegistration} icon="envelope">Resend Registration</ActionButton>
                    : null}
            </div>
        )
    }

    handleSave = () => {
        const me = this;
        me.checkSave(null);
    }

    checkSave = (cb) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }
        if (this._address !== null)
            this._address.register(this._form);
		if (this._mailingAddress !== undefined && this._mailingAddress !== null )
            this._mailingAddress.register(this._form);
        if (this._onboardDate !== null)
            this._onboardDate.register();
        if (this._activationDate !== null)
            this._activationDate.register();
        if (this._expirationDate !== null)
            this._expirationDate.register();

        const me = this;
        let form = this.state.form;
        if (form.savedActive === undefined || form.savedActive === form.active) {
            me.save();
            if (cb != null)
                cb();
        }
        else {
            var submitText = "";
            if (form.active)
                submitText = "<b>Warning!</b> Activating this Member will also mark all of the Associated Users as Active.<br /><br />" +
                    "If you wish to Activate this Member within VOCS, please select 'Yes'.<br /><br />" +
                    "If you wish to discard this change, please select 'No' and you will be returned to the previous screen.<br /><br />";
            else
                submitText = "<b>Warning!</b> Inactivating this Member will also mark all of the Associated Users as Inactive.<br /><br />" +
                    "If you wish to Inactivate this Member from VOCS, please select 'Yes'.<br /><br />" +
                    "If you wish to discard this change, please select 'No' and you will be returned to the previous screen.<br /><br />";

            Modals.confirm(
                submitText,
                function () {
                    me.save();
                    if (cb != null)
                        cb();
                }
            );
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();

		if (this.state.form.phones !== null && this.state.form.phones !== undefined && this.state.form.phones.length === 0)
            this.handleAddPhone();
    }

    handleAddressChange = (address) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					address: {
						addressId: address.addressId,
						street1: address.street1,
						street2: address.street2,
						zip: address.zip,
						city: address.city,
						stateCode: address.stateCode,
						county: address.county,
						province: address.province,
						countryCode: address.countryCode
					}
				}
			});
		});
    }

	checkBlankMailingAddressFields = (value) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					sameMailingAddress: value,
					mailingAddress: {
						addressId: prevState.form.mailingAddress != null ? prevState.form.mailingAddress.addressId : null,
						street1: "",
						street2: "",
						zip: "",
						city: "",
						stateCode: "",
						county: "",
						province: "",
						countryCode: "USA",
					}
				}
			});
		});
    }

	handleMailingAddressChange = (address) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					mailingAddress: {
						addressId: address.addressId,
						street1: address.street1,
						street2: address.street2,
						zip: address.zip,
						city: address.city,
						stateCode: address.stateCode,
						county: address.county,
						province: address.province,
						countryCode: address.countryCode,
					}
				}
			});
		});
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments, true);
    }

    handleAppReviewToolbar = (comments, canCompleteReview) => {
        this.handleUpdateComments(comments, canCompleteReview);
    }

    handleUpdateComments(comments, canCompleteReview) {
        let form = this.state.form;
        form.comments = comments;
        form.canCompleteReview = canCompleteReview;

        this.setState(form);
    }

	handleAddPhone = () => {
        const phones = this.state.form.phones

        phones.push({
            phoneTypeCode: 'MOBILE',
            number: '',
            extension: '',
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.setState({
            phones
        });
    }

    handleRemovePhone = (i) => {
        const phones = this.state.form.phones;

        phones[i].number = '';
        phones.splice(i, 1);

        this.setState({ form: { ...this.state.form, phones } })
        this.dirt()
    }

    handlePhoneChange = (v, i) => {
        const phones = this.state.form.phones

        phones[i] = v

        this.setState({ form: { ...this.state.form, phones } })
        this.dirt()
    }

	renderPhones = () => {
		const phoneTypes = ["Mobile", "Office"];

        return (
            this.state.form.phones.map((p, i) => (
                <div key={p.phoneId} className='form-inline'>
                    <PhoneBox
						types={phoneTypes}
                        value={p}
                        showExtension
                        onChange={(v) => this.handlePhoneChange(v, i)}
                        required={false}
                        ref={`phone_${i}`}
                    />
                    {i > 0 ?
                        <Button id="btnRemovePhone" bsStyle='link' title='Remove Phone' onClick={() => this.handleRemovePhone(i)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </Button> : null}
                </div>
            ))
        )
    }

	emailFocus = () => {
        this.setState({ form: {...this.state.form, originalEmail: this.state.form.userEmail }});
    }

    emailChange = () => {
		const me = this;
		
        if (this.state.form.originalEmail !== this.state.form.userEmail) {
            var rq = {
                email: this.state.form.userEmail
            };

            new APISystem().post(APIModules.Sponsor.url('/sponsorSetup/validateUserEmail'), rq, {
                success: (r) => {
                    if (r.data != null) {
						// Confirm if founded user will be used
						Modals.confirm(
							"A Corporate Member user with the same Email Address was found in the database. <br /><br />" +
							"If you wish to associate this user to the Corporate Member, please select 'Yes'. <br /><br />" +
							"If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
							function () {
								me.setState({
									form: {
										...me.state.form,
										disableUserFields: true,
										userId: r.data.userId,
										userFirstName: r.data.firstName,
										userLastName: r.data.lastName,
										userEmail: r.data.email,
										userTitle: r.data.title,
										userPrimaryPhone: r.data.primaryPhone
									}
								});
							}
						);
                    }
                    else {
                        me.setState({ form: {
							...me.state.form, 
							disableUserFields: false,
							userId: null
						}});
                    }
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                    me.setState({ form: {
						...me.state.form, 
						disableUserFields: false,
						userId: null
					}});
                }
            });
        }
    }

    renderForm() {
        const associatedUserTooltip = (
            <Tooltip id="associatedUserTooltip">
                In order to create a Member within VOCS, there needs to be an associated user
            </Tooltip>
        );

        const totalUsersTooltip = (
            <Tooltip id="totalUsers">
                Total users: {this.state.form.totalUsers}
                <br />
                Users with pending registration: {this.state.form.pendingUsers}
            </Tooltip>
        );

        const isSponsorHistoryMembershipTooltip = (
            <Tooltip id="isSponsorHistoryMembershipTooltip">
                Current Membership is associated to an invoice record. If you need to update or renew it please refer "Membership History" tab.
            </Tooltip>
        );

		const enableExpiration = App.hasPrivilege("AdminSponsorSetupEditExpiration")
		const enablePaymentTerms = App.hasPrivilege("AdminSponsorSetupEditPaymentTerms") || this.state.adding
        
        const expirationDateTooltip = (
            <Tooltip id='expirationDateTooltip'>
                <Row>
                    <Col md={12}>
                        {enableExpiration ?
						"You have permission to change the Expiration Date. If you want to apply the default expiration criteria (one year), leave the field empty"
						: "Expiration Date will be updated automatically according to 'Date Paid'"}.
                    </Col>
                </Row>
            </Tooltip>
        );

		const adding = this.state.adding;
		const disableUserFields = this.state.form.disableUserFields;

        return (
            <React.Fragment>
				<Row>
                    <Col md={5}>
                        <h3 className="inline">
                        Corporate Member Information
                        </h3>
                        <br /><br /><hr />
                    </Col>
					<Col md={7}>
                        <h3 className="inline">
                        Primary Point of Contact
						&nbsp;&nbsp;
						<small>
							<OverlayTrigger placement="right" overlay={associatedUserTooltip}>
								<FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
							</OverlayTrigger>
						</small>
                        </h3>
                        <br /><br /><hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label required>Corporate Member Name</Label>
                                    <TextBox
                                        name="sponsorName"
                                        placeholder="Member Name"
                                        maxLength={70}
                                        required
                                        ref={(c) => { this.focusControl = c; }} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Corporate Member Website</Label>
                                    <UrlBox
                                        name='website'
                                        placeholder='Member Website'
                                        maxLength={200}
                                    />
                                </FormGroup>
								{this.state.form.phones !== null && this.state.form.phones !== undefined && this.state.form.phones.length > 0 && (
									<FormGroup>
										<Label htmlFor="phoneNumber">Phone Number(s)</Label>
										{this.renderPhones()}
									</FormGroup>
								)}
								{this.state.form.phones !== null && this.state.form.phones !== undefined && this.state.form.phones.length < 5 && (
									<Button id="btnAddPhone" bsStyle='default' bsSize='xsmall' className='pull-right' onClick={this.handleAddPhone}>
										Add Phone
										<Glyphicon glyph='plus' style={{ marginLeft: 10 }} />
									</Button>
								)}
								<FormGroup style={{ marginTop: "45px" }}>
                                    <Switch name='active' labelLeft='Inactive' labelRight='Active' bsStyle='success' />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="subscribed">Receive email notifications?</Label>
                                    <Switch name="subscribed"
                                        labelLeft="No" 
                                        labelRight="Yes" 
                                        bsStyle='success'
                                        ref={(c) => { this._subscribed = c }} />
                                </FormGroup>
                            </Col>
							{(this.state.form.userEmail !== null || adding) && 
								<React.Fragment>
									<Col md={3}>
										<FormGroup>
											<Label required={adding}>First Name</Label>
											<TextBox placeholder="First Name" name="userFirstName" disabled={!adding || disableUserFields} required={adding} />
										</FormGroup>
										<FormGroup>
											<Label required={adding}>Last Name</Label>
											<TextBox placeholder="Last Name" name="userLastName" disabled={!adding || disableUserFields} required={adding} />
										</FormGroup>
										<FormGroup>
											<Label htmlFor="title">
												Title
											</Label>
											<TextBox
												name="userTitle"
												placeholder="Title"
												maxLength={200}
												disabled={!adding || disableUserFields} />
										</FormGroup>
										<FormGroup>
											<Label required={adding}>Email</Label>
											<EmailBox 
												placeholder="Email Address" 
												name="userEmail" 
												disabled={!adding} 
												required={adding}
												onBlur={this.emailChange}
                                                onFocus={this.emailFocus} />
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Label required={adding}>Primary Phone</Label>
											<div className="form-inline">
												<PhoneBox name="userPrimaryPhone" showExtension disabled={!adding || disableUserFields} required={adding} />
											</div>
										</FormGroup>
										<FormGroup>
											<Label>Best Time to be Contacted</Label>
											<BestContactTimeCombo name="userBestContactTimeCode" disabled={!adding} />
										</FormGroup>
										<FormGroup>
											<Label>Which Time Zone are you located?</Label>
											<TimeZoneCombo name="userTimeZoneCode" disabled={!adding} />
										</FormGroup>
									</Col>
								</React.Fragment>
							}
							{this.state.form.userEmail === null && !adding &&
								<Col md={7}>
									<Label style={{ color: 'red' }}>
										<em>There is no Primary Point of Contact set.</em>
									</Label>
								</Col>
							}
                        </Row>
                        <h3 style={{ marginTop: "0px" }}>Corporate Member Address</h3>
                        <hr />
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Address
                                        name="address"
										required
                                        ref={(c) => { this._address = c }}
                                        onChange={(address) => this.handleAddressChange(address)} />
									<CheckBox formControl={false} value={this.state.form.sameMailingAddress} onChange={this.checkBlankMailingAddressFields} name='sameMailingAddress' label='Mailing Address same as Corporate Address' />
								</FormGroup>
                            </Col>
                            {!adding ?
                                <Col md={7}>
                                    {this.renderActionButtons()}
                                </Col>
                                : null}
                        </Row>
						{this.state.form !== null && !this.state.form.sameMailingAddress ? (
							<React.Fragment>
								<h3>Mailing Address</h3>
								<hr />
								<Row>
									<Col md={5}>
										<FormGroup>
											<Address 
												name="mailingAddress" 
												required 
												ref={(c) => { this._mailingAddress = c }}
												onChange={(address) => this.handleMailingAddressChange(address)} />
										</FormGroup>
									</Col>
								</Row>
							</React.Fragment>
						) : null}
                        <h3 style={{ marginTop: "0px" }}>
                            Member Sponsorship Information
                            { this.state.form.isSponsorHistoryMembership ?
                                <React.Fragment>
                                    &nbsp;&nbsp;
                                    <small>
                                        <OverlayTrigger placement="right" overlay={isSponsorHistoryMembershipTooltip}>
                                            <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                        </OverlayTrigger>
                                    </small>
                                </React.Fragment>
                            : null }
                        </h3>
                        <hr />
                        <Row>
                            <Col md={5}>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label>Onboard Date</Label>
                                            <DatePicker
                                                name='onboardDate'
                                                placeholder='Onboard Date'
                                                managed={true}
                                                ref={(c) => { this._onboardDate = c }} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label required>Date Paid</Label>
                                            <DatePicker
                                                name='activationDate'
                                                placeholder='Date Paid'
                                                disabled={this.state.form.isSponsorHistoryMembership}
                                                ref={(c) => { this._activationDate = c }}
												required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                Expiration Date
                                                &nbsp;&nbsp;
                                                <OverlayTrigger placement="right" overlay={expirationDateTooltip}>
                                                    <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                                </OverlayTrigger>
                                            </Label>
                                            <DatePicker
                                                name='expirationDate'
                                                placeholder='Expiration Date'
                                                disabled={!enableExpiration}
                                                ref={(c) => { this._expirationDate = c }} />
                                        </FormGroup>
										<FormGroup>
											<Label htmlFor="paymentTerms">
												Payment Terms (Days)
											</Label>
											<TextBox
												name="paymentTerms"
												placeholder="Payment Terms in days"
												maxLength={50}
												disabled={!enablePaymentTerms} />
										</FormGroup>
                                    </Col>
                                    <Col md={8}>
                                        <FormGroup>
                                            <Label htmlFor='serviceBranchId' required>
                                                Membership Level
                                            </Label>
                                            <SponsorLevelCombo 
                                                name='sponsorLevelId' 
                                                placeholder="Membership Level"
                                                required
                                                disabled={this.state.form.isSponsorHistoryMembership} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Membership Amount</Label>
                                            <CurrencyBox
                                                name='membershipAmount'
                                                positiveNumbersOnly
                                                maxLength={6}
                                                precision={0}
                                                disabled={this.state.form.isSponsorHistoryMembership}
                                                required
                                                placeholder='Please provide whole numbers' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                { this.state.form.pendingUsers ?
                    <Row>
                        <Col md={12}>
                            <label style={{ color: 'red' }}>
                                <em>
                                    <span className="required-indicator">*</span>
                                    &nbsp; At least one associated user has not completed their Registration
                                </em>
                                &nbsp;&nbsp;
                                <OverlayTrigger placement="right" overlay={totalUsersTooltip}>
                                    <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                </OverlayTrigger>
                            </label>
                        </Col>
                    </Row>
                    : null}
                {!adding ?
                    <React.Fragment>
                        <br />
                        <hr />
                        <Row>
                            <Col md={12} style={{ paddingLeft: '0px' }}>
                                <SponsorCommentsGrid
                                    comments={this.state.form.comments}
                                    documents={this.state.form.reviewDocuments}
                                    sponsorId={this.props.selectedId}
                                    enableExport={true}
                                    entityId={this.state.form.sponsorId}
                                    onSave={this.handleCommentsGrid}
                                />
                            </Col>
                        </Row>
                    </React.Fragment>
                    : null}
            </React.Fragment>
        )
    }
}

export default SponsorInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/sponsorInfo/SponsorInfoTab.js